import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"
import { isValidEmailStrict } from "../../utils/validation"

export default class extends Controller {
  static targets = ["reservationUrlInput", "copyLinkButton", "sendTo"]

  connect() {
    this.initSendTo();
  }

  disconnect() {
    this.sendToChoices.destroy();
  }

  copyLink(event) {
    event.preventDefault();
    navigator.clipboard.writeText(this.reservationUrlInputTarget.value);

    this.copyLinkButtonTarget.textContent = "Copied!";
    this.copyLinkButtonTarget.classList.add("animate__animated", "animate__faster", "animate__pulse");

    setTimeout(() => {
      this.copyLinkButtonTarget.textContent = "Copy link";
      this.copyLinkButtonTarget.classList.remove("animate__animated", "animate__faster", "animate__pulse");
    }, 1000);
  }

  initSendTo() {
    fetch("/friends.json")
      .then(response => response.json())
      .then(data => {
        this.setupSendTo(data);
      })
      .catch(error => {
        console.error('Error fetching friends:', error);
      });
  }

  setupSendTo(data) {
    const friends = data.friends || data // Handle both old and new response formats
    this.sendToChoices = new Choices(this.sendToTarget, {
      choices: friends,
      searchFields: ['label'],
      removeItemButton: true,
      addChoices: true,
      customAddItemText: 'Enter an email address',
      addItemFilter: (value) => value && isValidEmailStrict(value),
    });
  }
}
